var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0617 4.39007C21.3728 4.07207 21.3728 3.5565 21.0617 3.2385C20.7505 2.9205 20.2461 2.9205 19.935 3.2385L16.7725 6.4708C15.3376 5.55046 13.7163 4.9 12 4.9C7.91186 4.9 4.36311 8.5904 2.58713 10.828C1.80429 11.8143 1.80429 13.1857 2.58713 14.172C3.37866 15.1693 4.52232 16.4551 5.90892 17.5742L2.93876 20.6099C2.62763 20.9279 2.62763 21.4435 2.93876 21.7615C3.24989 22.0795 3.75433 22.0795 4.06546 21.7615L21.0617 4.39007ZM8.67658 14.7454C8.25944 14.1018 8.01651 13.3299 8.01651 12.5C8.01651 10.2514 9.79998 8.42857 12 8.42857C12.812 8.42857 13.5672 8.67686 14.1969 9.10321L13.0306 10.2953C12.7186 10.1426 12.369 10.0571 12 10.0571C10.68 10.0571 9.60991 11.1508 9.60991 12.5C9.60991 12.8772 9.69355 13.2344 9.84291 13.5534L8.67658 14.7454Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5714C11.6918 16.5714 11.3917 16.5357 11.1036 16.4679L8.42459 19.2061C9.54185 19.7525 10.7455 20.1 12 20.1C16.0881 20.1 19.6369 16.4096 21.4129 14.172C22.1957 13.1857 22.1957 11.8143 21.4129 10.828C20.8216 10.0831 20.0339 9.17712 19.0952 8.29993L15.8822 11.5839C15.9485 11.8783 15.9835 12.185 15.9835 12.5C15.9835 14.7486 14.2 16.5714 12 16.5714Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.b7241475345611bb64ad7c5bae961f7b.svg";
export { ForwardRef as ReactComponent };